import { formField } from 'decorators'

import CustomerMultiSelect from 'components/customer/CustomerMultiSelect'

export default formField(CustomerMultiSelect)
